import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { getCurrentUser } from '@/composables/useAuth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomeView
    },
    {
      path: "/:customer",
      name: "Customer",
      component: () => import('@/views/CustomerView.vue')
    },
    {
      path: "/admin",
      name: "Admin",
      component: () => import("@/views/AdminView.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      // Public -- this is where the auth flow completes, so requiring auth
      // here would be a chicken-and-egg problem. handleCallback() is what
      // actually establishes the session.
      //
      // Must be a single path segment ("/callback", not "/admin/callback").
      // pomps-auth-api matches redirect URIs via a literal string
      // concatenation (referer + "callback", no path normalization) against
      // the Referer header of whatever page the login button lives on
      // (HomeView.vue, at "/"). Confirmed working as "http://localhost:5173/callback".
      path: "/callback",
      name: "AdminCallback",
      component: () => import("@/views/AdminCallbackView.vue")
    }
  ]
})

router.beforeEach(async (to, from) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if(requiresAuth && !await getCurrentUser()) {
    return from.fullPath
  }
})
export default router